import { useEffect, useState } from 'react';
import { qdfAPI } from '../../../services/api';
import {
  buildQDFAssetConfigFromShops,
  EMPTY_QDF_ASSET_CONFIG,
} from '../utils/shopConfig';

const useQDFShopConfig = () => {
  const [config, setConfig] = useState(EMPTY_QDF_ASSET_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setLoading(true);
      try {
        const response = await qdfAPI.getShops();
        const shops = response?.data?.shops || [];

        if (!isMounted) {
          return;
        }

        if (shops.length > 0) {
          setConfig(buildQDFAssetConfigFromShops(shops));
        } else {
          setConfig(EMPTY_QDF_ASSET_CONFIG);
        }
      } catch (error) {
        if (isMounted) {
          setConfig(EMPTY_QDF_ASSET_CONFIG);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { config, loading };
};

export default useQDFShopConfig;
